import { ResponsiveGridProps } from '@cbhq/cds-web';
import { Grid, VStack } from '@cbhq/cds-web/layout';

import { DashboardProvider, useDashboardContext } from ':cloud/contexts/DashboardProvider';
import { EventName, useLogViewOnMount } from ':cloud/init/clientAnalytics/logging';
import { Layout } from ':cloud/widgets/layout';
import { Chart } from ':cloud/widgets/monitoring/Chart';
import { DashboardHeader } from ':cloud/widgets/monitoring/DashboardHeader';
import { DashboardChart } from ':cloud/widgets/monitoring/types';
import { CloudErrorBoundary } from ':cloud/widgets/sharedcomponents';

function generateResponsiveGridConfig(numCharts: number): ResponsiveGridProps {
  return {
    phone: {
      columns: 1,
    },
    tablet: {
      columns: 1,
    },
    desktop: {
      columns: numCharts > 1 ? 2 : 1,
    },
  };
}

function MonitoringContent() {
  const { dashboard } = useDashboardContext();

  useLogViewOnMount(EventName.v2_monitor_page_view);

  const numCharts = dashboard?.charts.length || 0;

  return (
    <VStack>
      <DashboardHeader />
      <Grid responsiveConfig={generateResponsiveGridConfig(numCharts)} spacingVertical={4} gap={5}>
        {dashboard?.charts.map((chart: DashboardChart) => <Chart {...chart} key={chart.title} />)}
      </Grid>
    </VStack>
  );
}

export function MonitoringPage() {
  return (
    <Layout>
      <Layout.MainContainer fullWidth>
        <CloudErrorBoundary name="MonitoringContent">
          <DashboardProvider>
            <MonitoringContent />
          </DashboardProvider>
        </CloudErrorBoundary>
      </Layout.MainContainer>
    </Layout>
  );
}
